import React from 'react'
import { Container, Box, Typography, Grid, Divider, Button } from '@mui/material'
import { Link as RouterLink } from 'react-router-dom'
import HomeWorkIcon from '@mui/icons-material/HomeWork'
import PeopleIcon from '@mui/icons-material/People'
import PublicIcon from '@mui/icons-material/Public'
import NatureIcon from '@mui/icons-material/Nature'
import * as ROUTES from '../routes'

const VALUES = [
    {
        icon: <HomeWorkIcon sx={{ fontSize: 36, color: 'primary.main' }} />,
        title: 'Local Expertise',
        body: 'With deep roots in Dominica, we know every parish, every neighbourhood, and every opportunity the island has to offer.',
    },
    {
        icon: <PeopleIcon sx={{ fontSize: 36, color: 'primary.main' }} />,
        title: 'Trusted Partnerships',
        body: 'We build long-term relationships with buyers, sellers and investors — your goals are our goals from the first conversation to closing.',
    },
    {
        icon: <PublicIcon sx={{ fontSize: 36, color: 'primary.main' }} />,
        title: 'International Reach',
        body: 'Our listings attract buyers from across the Caribbean and beyond, giving your property maximum visibility in the right markets.',
    },
    {
        icon: <NatureIcon sx={{ fontSize: 36, color: 'primary.main' }} />,
        title: 'Island Living',
        body: 'We are passionate about Dominica — the Nature Isle. Every property we represent is a chance to share that passion with someone new.',
    },
]

export default function AboutScreen() {
    return (
        <Container maxWidth='lg' sx={{ py: { xs: 5, md: 8 } }}>

            {/* Hero */}
            <Box textAlign='center' mb={{ xs: 5, md: 7 }}>
                <Typography variant='overline' color='primary' sx={{ letterSpacing: '0.15em' }}>
                    Who We Are
                </Typography>
                <Typography variant='h2' sx={{ mt: 1, mb: 2 }}>
                    OUR VISION
                </Typography>
                <Typography
                    variant='body1'
                    color='text.secondary'
                    sx={{ maxWidth: 620, mx: 'auto', lineHeight: 1.8 }}
                >
                    Our Vision at Chouce REal Estate is to go above and beyond to deliver an experience that is fulfilling for our customers.
                </Typography>
            </Box>

            <Divider sx={{ mb: { xs: 5, md: 7 } }} />

            {/* Mission */}
            <Grid container spacing={6} alignItems='center' mb={{ xs: 6, md: 9 }}>
                <Grid item xs={12} md={6}>
                    <Typography variant='overline' color='primary' sx={{ letterSpacing: '0.15em' }}>
                        Our Mission
                    </Typography>
                    <Typography variant='h3' sx={{ mt: 1, mb: 2 }}>
                        Making property ownership accessible on the Nature Isle
                    </Typography>
                    <Typography variant='body1' color='text.secondary' sx={{ lineHeight: 1.8 }}>
                        Our Mission is to redefine the traditional model of buying and selling by creating a specialized package to give clients unparalled expertise and a positive experience.
                    </Typography>
                </Grid>
                <Grid item xs={12} md={6}>
                    <Box
                        sx={{
                            bgcolor: 'primary.light',
                            borderRadius: 3,
                            p: { xs: 3, md: 5 },
                            borderLeft: '4px solid',
                            borderColor: 'primary.main',
                        }}
                    >
                        <Typography variant='h5' sx={{ mb: 1.5, color: 'primary.main' }}>
                            "The Nature Isle deserves world-class real estate service."
                        </Typography>
                        <Typography variant='body2' color='text.secondary'>
                            — Choice Real Estate Team, Dominica
                        </Typography>
                    </Box>
                </Grid>
            </Grid>

            {/* Values */}
            <Box mb={{ xs: 6, md: 9 }}>
                <Typography variant='overline' color='primary' sx={{ letterSpacing: '0.15em', display: 'block', textAlign: 'center', mb: 1 }}>
                    What We Stand For
                </Typography>
                <Typography variant='h3' textAlign='center' mb={4}>
                    Our Values
                </Typography>
                <Grid container spacing={3}>
                    {VALUES.map(v => (
                        <Grid item xs={12} sm={6} key={v.title}>
                            <Box
                                sx={{
                                    display: 'flex',
                                    flexDirection: 'column',
                                    gap: 1.5,
                                    p: 3,
                                    borderRadius: 2,
                                    border: '1px solid',
                                    borderColor: 'divider',
                                    height: '100%',
                                    bgcolor: 'background.paper',
                                    boxShadow: 1,
                                    transition: 'box-shadow 0.2s',
                                    '&:hover': { boxShadow: 3 },
                                }}
                            >
                                {v.icon}
                                <Typography variant='h6'>{v.title}</Typography>
                                <Typography variant='body2' color='text.secondary' sx={{ lineHeight: 1.75 }}>
                                    {v.body}
                                </Typography>
                            </Box>
                        </Grid>
                    ))}
                </Grid>
            </Box>

            <Divider sx={{ mb: { xs: 5, md: 7 } }} />

            {/* CTA */}
            <Box textAlign='center'>
                <Typography variant='h4' mb={1.5}>
                    Ready to find your next property?
                </Typography>
                <Typography variant='body1' color='text.secondary' mb={3}>
                    Browse our current listings or get in touch with our team today.
                </Typography>
                <Box sx={{ display: 'flex', gap: 2, justifyContent: 'center', flexWrap: 'wrap' }}>
                    <Button
                        component={RouterLink}
                        to={`/${ROUTES.PROPERTIES}`}
                        variant='contained'
                        size='large'
                    >
                        Browse Listings
                    </Button>
                    <Button
                        component={RouterLink}
                        to={`/${ROUTES.CONTACT}`}
                        variant='outlined'
                        size='large'
                    >
                        Contact Us
                    </Button>
                </Box>
            </Box>

        </Container>
    )
}
